export default __webpack_public_path__ + "static/Stock-n-Ship-362478b9193a8dd09ca631c6837c2f6b.webp";